module.exports = __webpack_public_path__ + "Flag-660.e81952461f4ccbfd778bd35c95ab3b45.svg";